export const getColumnFormattedValue = (value: any, measureConfig: any, percent:any , currency:any, currencyCode:any) => {
    if(value === null || value === undefined || value === '' || isNaN(value) || !measureConfig){
        return value === null || value === undefined ? '' : value.toLocaleString();
    }
    if(!measureConfig.decimalPlaces) measureConfig.decimalPlaces = 2
    if (measureConfig.isCurrency) {
        return currency.transform(value, currencyCode, 'symbol', `1.${measureConfig.decimalPlaces}-${measureConfig.decimalPlaces}`);
    } else if (measureConfig.isPercent || measureConfig.isSplitPercent) {
        return percent.transform((+value) / 100, `1.${measureConfig.decimalPlaces}-${measureConfig.decimalPlaces}`);
    } else if (measureConfig.isDecimal) {
        return Number(value).toFixed( measureConfig.decimalPlaces);
    } else if (measureConfig.isRoundOff) {
        if (Math.abs(value) > 0 && Math.round(value) === 0) {
            return Number(value).toFixed(2);
        }
        return Math.round(value).toLocaleString();
    } else if (measureConfig.isComment) {
        return value;
    } else {
        return value.toLocaleString();
    }
}
